import { useCallback, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'

import { SK_AUTH_URL } from '@constants/envs'
import { authActions } from 'store/slices/auth'
import { useAppDispatch, useAppState } from 'store'
import { onboardingActions } from 'store/slices/onboarding'

export function useInitApp() {
	const dispatch = useAppDispatch()
	const { authorized } = useAppState(state => state.auth)
	const hasInitialized = useRef(false)
	const lastAuthorizedState = useRef(authorized)

	const init = useCallback(async () => {
		if (!authorized) {
			return;
		}

		const res = await dispatch(authActions.getMe())
		if (res.meta.requestStatus !== 'fulfilled') {
			globalThis.location.replace(`${SK_AUTH_URL}/?convos`)
			return
		}

		dispatch(onboardingActions.getOnboardingStages({}))
		hasInitialized.current = true
	}, [authorized, dispatch])

	useEffect(() => {
		// Only run init if:
		// 1. We haven't initialized yet, OR
		// 2. authorized state changed from false to true
		const shouldInit = !hasInitialized.current || (authorized && !lastAuthorizedState.current)
		
		if (shouldInit) {
			init()
		}
		
		lastAuthorizedState.current = authorized
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [authorized])

	return { authorized }
}
